<template>
  <dl class="product-specs">
    <template v-if="productVendor">
      <dt>Licensor:</dt>
      <dd>
        <nuxt-link :to="`/shop/sound-designer/${productVendor.slug}`">
          {{ productVendor.name }}
        </nuxt-link>
      </dd>
    </template>
    <template v-if="showSkeletonLoading || productCategories">
      <dt>
        Categories:
      </dt>
      <dd v-if="showSkeletonLoading" class="product-specs__skeleton-loading product-specs__skeleton-text" />
      <dd v-else>
        <ul class="product-specs__child-list">
          <li v-for="category in productCategories.nodes" :key="category.name">
            <nuxt-link :to="category.uri.replace('sound-category', 'shop/category')">
              {{ category.name }}
            </nuxt-link>
          </li>
        </ul>
      </dd>
    </template>
    <dt>
      Specs:
    </dt>
    <dd v-if="showSkeletonLoading" class="product-specs__skeleton-loading product-specs__skeleton-text" />
    <dd v-else v-html="fileData" />
    <template v-if="productSpecs.totalDuration && ! productSpecs.showVariationSpecs">
      <dt>
        Duration:
      </dt>
      <dd>
        Approx. {{ productSpecs.totalDuration }} minutes total
      </dd>
    </template>
    <dt>
      Delivery:
    </dt>
    <dd>
      Instant - blazingly-fast - digital download
    </dd>
    <dt>
      License type:
    </dt>
    <dd>
      Royalty-free - you can select the number of users on checkout
    </dd>
  </dl>
</template>

<script>

export default {
  props: {
    productId: Number,
    productSpecs: Object,
    productCategories: Object,
    productVendor: Object,
    productName: String,
    showSkeletonLoading: Boolean,
  },
  computed: {
    fileData() {
      let fileDetails = [];

      const incSuffix = ! this.productSpecs.showVariationSpecs;

      if (this.productSpecs.soundsIncluded) {
        fileDetails.push(`${this.productSpecs.soundsIncluded}${ incSuffix ? ' sounds' : '' }`);
      }

      if (this.productSpecs.filesIncluded) {
        fileDetails.push(`${this.productSpecs.filesIncluded}${ incSuffix ? ' files' : '' }`);
      }

      if (this.productSpecs.format) {
        fileDetails.push(`${this.productSpecs.format}`);
      }

      if (this.productSpecs.totalSize && ! this.productSpecs.showVariationSpecs) {
        fileDetails.push(`${this.productSpecs.totalSize}`);
      }

      if (this.productSpecs.metatagged) {
        fileDetails.push('Includes metadata');
      } else {
        fileDetails.push('No metadata');
      }

      return fileDetails.join(" &bull; ");
    }
  },
}
</script>

<style lang="scss">
@use "~/common/scss/skeleton";

.product-specs {
  @include skeleton.loading();
  align-items: baseline;
  display: grid;
  gap: .4rem .25rem;
  grid-template: "title data" auto / auto 1fr;

  dt {
    font-weight: bold;
  }

  a {
    color: currentColor;
  }

  &__child-list {
    display: flex;
    flex-flow: row wrap;
    gap: .25rem .33rem;
    list-style: none;
    max-height: 150px;
    overflow-y: auto;

    li:not(:last-child) {

      &::after {
        content: ", ";
      }
    }
  }
}
</style>
